import { CKEditor } from "ckeditor4-react";
import { FooterPortal, NavbarPortal, SearchPortal } from "components";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  API_URL_apiSetting,
  API_URL_department,
  API_URL_ticket,
  API_URL_ticketPriority,
} from "constants/api";
import { getData, isAuth } from "actions";
import { AuthContext } from "context/AuthContext";
import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";
import { ticketPriorityReducers } from "redux/ticketPrioritySlice";
import { departmentReducers } from "redux/departmentSlice";
import { FaPaperclip } from "react-icons/fa";
import { byteToKiloByte } from "utils/byteToKiloByte";

const CreateTicket = () => {
  const dispatch = useDispatch();
  const { datauser } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [resetEditor, setResetEditor] = useState(false);
  const [auth, setAuth] = useState(false);
  const [canChangePriority, setCanChangePriority] = useState(0);

  const { getDepartmentResult, getTicketPriorityResult } = useSelector(
    (state) => ({
      getDepartmentResult: state.department.getDepartmentResult,
      getTicketPriorityResult: state.ticketPriority.getTicketPriorityResult,
    })
  );

  const getDepartment = useCallback(
    async (params) => {
      getData(
        API_URL_department,
        params,
        { dispatch, redux: departmentReducers },
        "GET_DEPARTMENT"
      );
    },
    [dispatch]
  );

  const getTicketPriority = useCallback(
    async (params) => {
      getData(
        API_URL_ticketPriority,
        params,
        { dispatch, redux: ticketPriorityReducers },
        "GET_TICKETPRIORITY"
      );
    },
    [dispatch]
  );

  const getCanChangePriority = () => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "GET",
      url: API_URL_apiSetting + "change_priority/",
    })
      .then((response) => {
        setCanChangePriority(parseInt(response.data.value));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formik = useFormik({
    initialValues: {
      department: "",
      priority: null,
      title: "",
      body: "",
      files: [],
    },
    validationSchema: Yup.object({
      department: Yup.string().required("Topik Department harus diisi"),
      title: Yup.string().required("Subjek harus diisi"),
      body: Yup.string().required("Detail harus diisi"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const formData = new FormData();

      formData.append("department", values.department);
      formData.append("priority", values.priority);
      formData.append("source", 1);
      formData.append("status", 1);
      formData.append("rating", 0);
      formData.append("ratingreply", 0);
      formData.append("ip_address", "0.0.0.0");
      formData.append("user", datauser.id);
      formData.append("isoverdue", 0);
      formData.append("reopened", 0);
      formData.append("isanswered", 0);
      formData.append("closed", 0);
      formData.append("is_transferred", 0);
      formData.append("approval", 0);
      formData.append("follow_up", 0);
      formData.append("title", values.title);
      formData.append("body", values.body);
      formData.append("is_internal", 0);

      // Menggunakan values.files untuk mengambil daftar file yang dipilih
      values.files.forEach((file, index) => {
        formData.append(`file_${index}`, file);
      });

      axios({
        method: "POST",
        data: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        url: API_URL_ticket,
      })
        .then((response) => {
          setLoading(false);
          formik.resetForm();
          setResetEditor(!resetEditor);
          formik.setFieldValue("body", "");
          const nomorTiket = response.data.data.ticket_number;
          if (nomorTiket !== null) {
            toast.success(
              `Tiket Anda berhasil dibuat, nomor tiket Anda ${nomorTiket} silakan lihat tiket Anda di menu Tiket Saya`,
              {
                position: "top-center",
                autoClose: false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              }
            );
          } else {
            toast.success(
              `Tiket Anda berhasil dibuat, namun email anda termasuk Banlist atau tiket Anda mengandung kata kata Spam selalu check di My Ticket atau email Anda, Team kami akan melakukan review terlebih dahulu`,
              {
                position: "top-center",
                autoClose: false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              }
            );
          }
        })
        .catch((error) => {
          if (error.response.data && error.response.status !== 500) {
            // Jika respons mengandung data objek, tampilkan sebagai daftar
            Swal.fire({
              icon: "error",
              title: "Oops...",
              customClass: {
                container: "z-[99999]",
              },
              html: `
              <div>
                <ul>
                  ${(() => {
                    const entries = Object.entries(error.response.data);
                    return entries
                      .map(([key, value], index) => {
                        if (entries.length === 1) {
                          return `<li>${value}</li>`;
                        } else {
                          return `<li><strong>${key}</strong>: ${value}</li>`;
                        }
                      })
                      .join("");
                  })()}
                </ul>
              </div>
            `,
            });
          } else {
            // Jika respons tidak mengandung data objek, tampilkan pesan error langsung
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message,
            });
          }
        });
    },
  });

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };

  useEffect(() => {
    const params = `?limit=${9999999}`;
    getDepartment(params);
    getTicketPriority(params);
    getCanChangePriority();
  }, []);

  useEffect(() => {
    const auth = isAuth();
    if (auth !== false) {
      setAuth(true);
    } else {
      window.location.href = "https://akun.apjii.or.id";
    }
  }, []);

  if (!auth) {
    return null;
  } else {
    return (
      <>
        <div className="flex flex-col min-h-screen overflow-y-auto text-neutral-700">
          {/* Navbar  */}
          <NavbarPortal current={"Buat Tiket"} />
          <SearchPortal />
          <main className="flex flex-grow">
            <div className="mx-auto w-full max-w-[90rem] md:px-8 bg-transparent">
              <div className="relative mx-1 md:mx-0 bottom-6 bg-neutral-50 shadow-sm shadow-sky-800 rounded">
                <div className="mx-4 md:mx-10 py-2 md:py-4">
                  <p className="text-2xl font-bold">Buat Tiket</p>
                  <hr className="border-t-4 mb-5 mt-2" />
                  <form onSubmit={formik.handleSubmit}>
                    <div className="mb-4">
                      <label className="font-semibold mb-1 block">
                        Topik Departement
                        <span className="text-red-500">*</span>
                      </label>
                      <select
                        id="department"
                        value={formik.values.department}
                        onChange={formik.handleChange}
                        className="w-full p-1.5  border border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                      >
                        <option value="" className="font-semibold">
                          Pilih Topik
                        </option>
                        {getDepartmentResult.results &&
                          getDepartmentResult.results.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </select>
                      {formik.touched.department &&
                        formik.errors.department && (
                          <div className="text-red-500">
                            {formik.errors.department}
                          </div>
                        )}
                    </div>

                    {canChangePriority === 1 && (
                      <div className="mb-4">
                        <label className="font-semibold mb-1 block">
                          Prioritas
                        </label>
                        <select
                          id="priority"
                          value={formik.values.priority}
                          onChange={formik.handleChange}
                          className="w-full p-1.5  border border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                        >
                          <option value="" className="font-semibold">
                            Pilih Prioritas
                          </option>
                          {getTicketPriorityResult.results &&
                            getTicketPriorityResult.results.map(
                              (item, index) => (
                                <option key={index} value={item.id}>
                                  {item.priority}
                                </option>
                              )
                            )}
                        </select>
                        {formik.touched.priority && formik.errors.priority && (
                          <div className="text-red-500">
                            {formik.errors.priority}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="mb-4">
                      <label className="font-semibold mb-1 block">
                        Subjek <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="title"
                        placeholder="Subjek"
                        type="text"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                        className="w-full p-1  border border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                      />
                      {formik.touched.title && formik.errors.title && (
                        <div className="text-red-500">
                          {formik.errors.title}
                        </div>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="font-semibold mb-1 block">
                        Body <span className="text-red-500">*</span>
                      </label>
                      <div className="w-full">
                        <CKEditor
                          key={resetEditor}
                          config={toolbarConfig}
                          type="classic"
                          initData={formik.values.body}
                          onChange={(e) => {
                            formik.setFieldValue("body", e.editor.getData());
                          }}
                        />
                        {formik.touched.body && formik.errors.body && (
                          <div className="text-red-500">
                            {formik.errors.body}
                          </div>
                        )}
                      </div>

                      {formik.touched.body && formik.errors.body && (
                        <div className="text-red-500">{formik.errors.body}</div>
                      )}
                    </div>

                    <div className="col-span-12 md:col-span-2 mb-2">
                      <label className="font-bold">File Tambahan :</label>
                    </div>
                    <div className="col-span-12 md:col-span-10 mb-4">
                      <div className="flex items-center mb-2">
                        <label className="p-1 px-3 flex items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white">
                          <FaPaperclip />
                          <span>Pilih File [Accept Multiple]</span>
                          <input
                            type="file"
                            id="file"
                            name="file"
                            className="hidden"
                            multiple // Izinkan pengguna untuk memilih beberapa file
                            onChange={(e) => {
                              const selectedFiles = Array.from(e.target.files);
                              const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                              const allowedExtensions = [
                                ".doc",
                                ".docx",
                                ".jpeg",
                                ".png",
                                ".webp",
                                ".pdf",
                                ".xls",
                                ".xlsx",
                                ".jpg",
                                ".DOC",
                                ".DOCX",
                                ".JPEG",
                                ".PNG",
                                ".WEBP",
                                ".PDF",
                                ".XLS",
                                ".XLSX",
                                ".JPG",
                              ];

                              const validFiles = selectedFiles.filter(
                                (file) => {
                                  const fileExtension = file.name
                                    .split(".")
                                    .pop();

                                  if (file.size > maxSize) {
                                    // Validasi ukuran file
                                    toast.warning(
                                      `File ${file.name} exceeds the size limit (5MB).`,
                                      {
                                        position: "top-center",
                                        autoClose: true,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                      }
                                    );
                                    return false;
                                  } else if (
                                    !allowedExtensions.includes(
                                      `.${fileExtension.toLowerCase()}`
                                    )
                                  ) {
                                    // Validasi ekstensi file
                                    toast.warning(
                                      `File ${file.name} has an unsupported extension.`,
                                      {
                                        position: "top-center",
                                        autoClose: true,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                      }
                                    );
                                    return false;
                                  }

                                  return true;
                                }
                              );

                              // Update the 'files' array in one go
                              formik.setFieldValue("files", [
                                ...formik.values.files,
                                ...validFiles,
                              ]);
                            }}
                          />
                        </label>
                        <p className="ml-2">
                          Each file upload is a maximum of 5Mb
                          [doc,docx,jpeg,png,webp,pdf,xls,xlsx,jpg]
                        </p>
                      </div>

                      {formik.values.files.map((file, index) => (
                        <div
                          key={index}
                          className="md:flex md:flex-row items-center justify-between bg-blue-100 dark:bg-blue-800 text-blue-500 dark:text-blue-100 p-2 rounded-lg mb-2 w-full lg:w-1/2"
                        >
                          <span className="mr-2 flex-wrap">
                            {file.name} ({byteToKiloByte(file.size)} KB)
                          </span>
                          <button
                            type="button"
                            onClick={() => {
                              // Hapus file dari daftar saat pengguna mengklik tombol
                              const updatedFiles = [...formik.values.files];
                              updatedFiles.splice(index, 1);
                              formik.setFieldValue("files", updatedFiles);
                            }}
                            className="text-red-500 hover:text-red-700 ml-2 cursor-pointer"
                          >
                            Delete
                          </button>
                        </div>
                      ))}
                    </div>

                    <button
                      type="submit"
                      className="bg-sky-500 text-white rounded px-3 py-1"
                    >
                      {loading ? (
                        <PulseLoader color="#0000" size={11} />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </main>

          <FooterPortal />
        </div>
      </>
    );
  }
};

export default CreateTicket;
